import { styled, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";

import { useTranslation } from "react-i18next";

import {
  useFilteredMeasures,
  useFilteredMeasuresFilterSelection,
} from "hooks/measureHooks";

import { FilterOption, MeasureImpact } from "types/types";

import { MeasureContentItem } from "./addMeasurePage/MeasureContentItem";

interface Props {
  measureImpacts: MeasureImpact[];
  search: string;
  selectedFilter: FilterOption;
  onSelectMeasure: (measure: MeasureImpact) => void;
}

export function MeasureSelection(props: Props) {
  const { measureImpacts, search, selectedFilter, onSelectMeasure } = props;
  const { t } = useTranslation();
  const filteredMeasuresImpacts = useFilteredMeasures(measureImpacts, search);

  const filteredMeasureImpacts = useFilteredMeasuresFilterSelection(
    selectedFilter,
    filteredMeasuresImpacts
  );

  return (
    <StyledPaper layout>
      <AnimatePresence>
        {filteredMeasureImpacts.length === 0 && (
          <Typography>{t("label.noResultsFound")}</Typography>
        )}

        {filteredMeasureImpacts.map((measureImpact) => (
          <MeasureContentItem
            key={measureImpact.measure.id}
            measureImpact={measureImpact}
            onSelectMeasure={onSelectMeasure}
          />
        ))}
      </AnimatePresence>
    </StyledPaper>
  );
}

const StyledPaper = styled(motion.div)`
  overflow-y: auto;
  display: grid;
  height: 100%;
  padding-right: ${({ theme }) => theme.spacing(2)};
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};

  column-gap: ${({ theme }) => theme.spacing(4)};
  row-gap: ${({ theme }) => theme.spacing(3)};
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-template-rows: repeat(auto-fill, 150px);
  margin-right: -${({ theme }) => theme.spacing(4)};
`;
